import React from 'react';
import './UserTypes.css';
import { useLanguage } from '../LanguageContext';
import storytellerImage from '../assets/images/user-top.png';
import travelerImage from '../assets/images/user-bottom.png';

const UserTypes = () => {
  const { t } = useLanguage();
  
  return (
    <div className="user-types">
      <div className="user-type-section">
        <div className="illustration-container">
          <img src={storytellerImage} alt="Storyteller" className="user-illustration" />
        </div>
        
        <div className="user-content">
          <h2 className="user-title">{t('storytellersTitle')}</h2>
          <div className="title-underline orange"></div>
          <h3 className="user-subtitle">{t('storytellersSubtitle')}</h3>
          
          <ul className="user-features">
            <li>{t('storytellersFeat1')}</li>
            <li>{t('storytellersFeat2')}</li>
            <li>{t('storytellersFeat3')}</li>
          </ul>
        </div>
      </div>

      <div className="user-type-section reverse">
        <div className="user-content">
          <h2 className="user-title">{t('travelersTitle')}</h2>
          <div className="title-underline blue"></div>
          <h3 className="user-subtitle">{t('travelersSubtitle')}</h3>
          
          <ul className="user-features">
            <li>{t('travelersFeat1')}</li>
            <li>{t('travelersFeat2')}</li>
            <li>{t('travelersFeat3')}</li>
          </ul>
        </div>
        
        <div className="illustration-container">
          <img src={travelerImage} alt="Traveler" className="user-illustration" />
        </div>
      </div>
    </div>
  );
};

export default UserTypes;
